// removed by extract-text-webpack-plugin
module.exports = {"currentSetting":"G4f0d05"};